import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Protected from './pages/Protect';
import Utama from './pages/Home';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Daftar from './pages/Daftar';
import VerifikasiKodeOtp from './pages/VerifikasiKodeOtp';
import SetAkun from './pages/SetAkun';
import RefKelas from './pages/refrensi/Kelas';
import RefMapel from './pages/refrensi/Mapel';
import PendidikPembelajaran from './pages/pendidik/Pembelajaran';
import PendidikSubtes from './pages/pendidik/Subtes';
import ViewEvaluasi from './pages/pendidik/ViewEvaluasi';
import IdentifikasiAkses from './pages/IdentifikasiAkses';
import RefPendidik from './pages/refrensi/Pendidik';
import JadwalUjian from './pages/refrensi/JadwalUjian';
import HasilUjian from './pages/pendidik/HasilTex';
import DaftarTesGuru from './pages/refrensi/DaftarTesGuru';
import RefPd from './pages/refrensi/Pd';
import Sycron from './pages/refrensi/Sycron';
import { HelmetProvider } from "react-helmet-async";
import Pengaturan from './pages/refrensi/Pengaturan';
import ComingSooon from './components/ComingSoon';
import RefPembelajaan from './pages/refrensi/Pembelajaran';
import Profile from './pages/profile';
import LupaPassword from './pages/LupaPassword';
import SetLupaPassword from './pages/SetLupaPassword';

const App = () => {
  return (
    <HelmetProvider>
    <Router>
      <Routes>
        {/* Rute untuk Login */}
        <Route index element={<Login />} />
        <Route path="login" element={<Login />} />
        <Route path="daftar" element={<Daftar />} />
        <Route path="daftar/verifikasiotp" element={<VerifikasiKodeOtp />} />
        <Route path="daftar/setakun" element={<SetAkun />} />
        <Route path="daftar/identifikasiakses" element={<IdentifikasiAkses />} />
        <Route path="lupapassword" element={<LupaPassword />} />
        <Route path="setlupapassword" element={<SetLupaPassword />} />

        
        
        {/* Pendidik */}
        <Route
          path="pendidik"
          element={
            <ProtectedRoute>
              <Protected />
            </ProtectedRoute>
          }
        ><Route index element={<ProtectedRoute><Utama /></ProtectedRoute>} />
          <Route path="pembelajaran" element={ <ProtectedRoute><PendidikPembelajaran /></ProtectedRoute>} />
          <Route path="subtes" element={ <ProtectedRoute><PendidikSubtes /></ProtectedRoute>} />
          <Route path="viewevaluasi" element={ <ProtectedRoute><ViewEvaluasi /></ProtectedRoute>} />
          <Route path="hasilujian" element={ <ProtectedRoute><HasilUjian /></ProtectedRoute>} />
        </Route>

        {/* Admin */}
        <Route
          path="admin"
          element={
            <ProtectedRoute>
              <Protected />
            </ProtectedRoute>
          }
        >
          <Route index element={<Utama />} />
          <Route path="refrensi/kelas" element={<ProtectedRoute><RefKelas /></ProtectedRoute>} />
          <Route path="refrensi/mapel" element={<ProtectedRoute><RefMapel /></ProtectedRoute>} />
          <Route path="refrensi/pendidik" element={<ProtectedRoute><RefPendidik /></ProtectedRoute>} />
          <Route path="refrensi/jadwalujian" element={<ProtectedRoute><JadwalUjian /></ProtectedRoute>} />
          <Route path="refrensi/daftartesguru" element={<ProtectedRoute><DaftarTesGuru /></ProtectedRoute>} />
          <Route path="refrensi/pd" element={<ProtectedRoute><RefPd /></ProtectedRoute>} />
          <Route path="refrensi/sycron" element={<ProtectedRoute><Sycron /></ProtectedRoute>} />
          <Route path="refrensi/pengaturan" element={<ProtectedRoute><Pengaturan /></ProtectedRoute>} />

          <Route path="refrensi/pembelajaran" element={<ProtectedRoute><RefPembelajaan /></ProtectedRoute>} />

          <Route path="comingsoon" element={<ComingSooon />} />
          <Route path="profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />


          
        </Route>
      </Routes>
    </Router>
    </HelmetProvider>
  );
};

export default App;
